import { styled } from "goober";
import { type GroupedRoleChip, roleIdFromChipKey } from "../../lib/roleChip";
import { openRoleModal } from "../globalModalStack";
import { Text } from "../Text";
import { Tooltip } from "../Tooltip";
import { OverflowBadges } from "./OverflowBadges";
import { ClickablePillBadge, PillBadge } from "./shared";

const PillBadgeCount = styled("span")`
  margin-left: 4px;
  opacity: 0.6;
  font-variant-numeric: tabular-nums;
`;

export function RoleBadgeList({
  chips,
}: {
  chips: readonly GroupedRoleChip[];
}) {
  if (chips.length === 0) {
    return (
      <Text variant="text-small" color="var(--text-tertiary)">
        No roles
      </Text>
    );
  }
  return (
    <OverflowBadges
      items={chips}
      keyFn={(chip) => chip.key}
      renderBadge={(chip) => {
        const showCount = chip.scopeKind !== "tenant" || chip.key === "tenant";
        const showTooltip = showCount && chip.details.length > 0;
        if (chip.key === "full-access") {
          return <PillBadge icon={chip.icon}>{chip.label}</PillBadge>;
        }
        const handleClick = () => {
          openRoleModal(roleIdFromChipKey(chip.key));
        };
        const badge = (
          <ClickablePillBadge icon={chip.icon} onClick={handleClick}>
            {chip.label}
            {showCount && <PillBadgeCount>{chip.count}</PillBadgeCount>}
          </ClickablePillBadge>
        );
        return showTooltip ? (
          <Tooltip content={chip.details.join(", ")}>{badge}</Tooltip>
        ) : (
          badge
        );
      }}
      overflowTooltip={(hidden) => hidden.map((c) => c.label).join(", ")}
    />
  );
}
